export default __webpack_public_path__ + "static/netherlands-organization-ea56211468234e5f72d37ae0824599fd.png";